import { EType } from '../../repositories/newbuilding-reviews/entities/create_review/Comment';
import { TCreateReviewRequest } from '../../repositories/newbuilding-reviews/v1/create-review';
import { INewReview } from '../../types/newReview';

export const prepareNewReviews = (newbuildingId: number, newReview: INewReview): TCreateReviewRequest => {
  return {
    newbuildingId,
    rating: {
      common: newReview.data.generalRating.value,
      ecology: newReview.data.ecologyRating.value,
      infrastructure: newReview.data.infrastructureRating.value,
      priceQuality: newReview.data.priceAndQualityBalanceRating.value,
      transport: newReview.data.transportRating.value,
    },
    comment: {
      negative: newReview.data.cons.value,
      positive: newReview.data.pros.value,
      type: newReview.data.userStatus.value as unknown as EType,
    },
    userName: newReview.data.name.value,
    isAnonymous: newReview.data.isAnonymous.value,
  };
};
